<template>
  <v-row no-gutters v-if="product">
    <v-col cols="9" class="pr-1">
      <CardContainer elevation="0" tile >
        <template v-slot:content>
          <v-row class="detailbg">
            <v-col cols="4">
              <v-img :src="image" position="top"/>
            </v-col>
            <v-col cols="8">
              <v-row>
                <v-col cols="12" v-html="product.description" class="description"/>
              </v-row>
              <v-row class="details">
                <v-col cols="3" class="detail_name">
                  {{ text.pages.product.category }}:
                </v-col>
                <v-col cols="9">
                  <router-link
                    v-for="ctg in product.categories"
                    :key="ctg.name"
                    :to="`/category/${ctg.slug}`"
                    class="detail_link"
                  >{{ ctg.name }},
                  </router-link>
                </v-col>
                <v-col cols="3" class="detail_name">
                  {{ text.pages.product.language }}:
                </v-col>
                <v-col cols="9" class="detail_link">{{ language }}</v-col>
                <v-col cols="3" class="detail_name">
                  {{ text.pages.product.pegi }}:
                </v-col>
                <v-col cols="9" class="detail_link">{{
                    product.pegi.name
                  }}
                </v-col>
                <v-col cols="3" class="detail_name">
                  {{ text.pages.product.available }}:
                </v-col>
                <v-col cols="9" class="detail_link">{{ product.additional_info }}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </CardContainer>
    </v-col>

    <v-col cols="3" class="pl-1">
      <CardContainer elevation="0" tile>
        <template v-slot:content>
          <v-row align="center" class="detailbg">
            <v-col cols="12" class="text-center">
              <v-row>
                <v-col cols="6" offset="3" class="text-h5" v-if="product.current_promotion">
                  <div>{{ $store.state.text.common.price }}</div>
                  <div class="text-decoration-line-through">
                    {{ product.current_product_price.price_gross }}
                    {{ $store.state.text.common.currency }}
                  </div>
                </v-col>

                <v-col cols="6" offset="3" class="text-center text-h5 color-primary">
                  {{ text.common.priceForYou }}
                  <div v-if="product.current_promotion" class="text-xl-h4">
                    <strong>
                      {{ product.current_promotion.price_gross }}
                      {{ $store.state.text.common.currency }}
                    </strong>
                  </div>
                  <div v-else-if="product.current_product_price" class="text-xl-h4">
                    <strong>
                      {{ product.current_product_price.price_gross }}
                      {{ $store.state.text.common.currency }}
                    </strong>
                  </div>
                </v-col>

                <v-col cols="12" class="text-center">
                  <v-btn large outlined color="primary" tile @click="addProductToBasket">
                    {{ text.common.addToCart }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </CardContainer>
    </v-col>
  </v-row>
</template>

<script>
import CardContainer from '@/components/Partials/CardContainer.vue';
import Basket from '@/core/Basket';
import { translations } from '@/lang/translations';

export default {
  name: 'ProductDesktop',
  components: { CardContainer },
  props: ['productDetails'],
  data() {
    return {
      basket: new Basket(),
      url: process.env.VUE_APP_URL,
    };
  },
  computed: {
    product() {
      return this.productDetails;
    },
    text() {
      return translations[this.$store.state.language];
    },
    image() {
      if (this.product.image.length === 0) {
        return '/img/norbit_nocover.png';
      }
      const imageBox = this.product.image
        .filter((value) => parseInt(value.pivot.image_type_id, 10) === 3);
      if (imageBox.length === 0) {
        return '/img/norbit_nocover.png';
      }
      return this.url + imageBox[0].pivot.image_link;
    },
    language() {
      const lang = this.product.attributes
        .filter((value) => parseInt(value.pivot.attribute_id, 10) === 1);
      if (lang.length > 0) {
        return lang[0].name;
      }
      return 'EN';
    },
  },
  methods: {
    addProductToBasket() {
      const price = this.product.current_promotion ? this.product.current_promotion.price_gross
        : this.product.current_product_price.price_gross;
      this.basket.addItemToBasket(this.product.id, this.product.name, price);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Lato:400,700");
.description. {
  font-family: 'Lato', sans-serif;
  color: #bcbcbc;
}

.details {
  margin-left: 1.5em;
  line-height: 0.1em;
}

.detail_name {
  color: #000000;
}

.detail_link {
  color: #bcbcbc;
  text-decoration: none;
}

.detailbg {
  min-height: 30em;
}

.color-primary {
  color: #0086ca;
}
</style>
